module.exports = __webpack_public_path__ + "static/media/ClickHere_Button@3x.17010fc8.png";